<template>
    <div class=" "
         :class="{'TQ_centerAbsolute' : co_isWindows_b || co_isMac_b, 'TQ_margin_8px' :  co_isAndroid_b || co_isIos_b}"
         :style="{'direction' : helper_getDirectionByLangCode_fe(p_system_langCode_e)}">

        <div class="TQ_maxWidth_300px TQ_center TQ_padding_16px TQ_bg_white TQ_padding_16px TQ_borderRadius TQ_box_shadow">

            <img :src="ass_img_logoFull_p" class="TQ_width_100px TQ_borderRadius TQ_margin_8px TQ_box_shadow"/>

            <div class="TQ_text_24px TQ_textColor_purple">
                {{ass_strings.fourWords_welcomeToTravelQuest[p_system_langCode_e]}}
            </div>

            <hr>

            <!-- warning text-->
            <div class="TQ_padding_8px">


                <!-- android -->
                <div v-if="co_isAndroid_b" >
                    <div>
                        {{ass_strings.sentence_browserSuggestionsAndroid[p_system_langCode_e]}}.
                    </div>
                    <div class="TQ_padding_8px"></div>
                    <div class="TQ_direction_ltr">
                        <img :src="ass_img_logoFull_p" class="TQ_width_44px TQ_margin_4px TQ_verticalAlignMiddle TQ_borderRadius"/>
                        <img :src="ass_img_plusSign_b" class="TQ_width_28px TQ_margin_4px TQ_verticalAlignMiddle"/>
                        <img :src="ass_img_logoAndroid_c" class="TQ_width_44px  TQ_verticalAlignMiddle"/>
                        <img :src="ass_img_equal_b" class="TQ_width_28px TQ_margin_4px TQ_verticalAlignMiddle"/>
                        <img :src="ass_img_chrome_c" class="TQ_width_44px TQ_margin_8px TQ_verticalAlignMiddle"/>
                    </div>
                </div>

                <!-- ios -->
                <div v-if="co_isIos_b">
                    <div>
                        {{ass_strings.sentence_browserSuggestionsApple[p_system_langCode_e]}}.
                    </div>
                    <div class="TQ_padding_8px"></div>
                    <div class="TQ_direction_ltr" >
                        <img :src="ass_img_logoFull_p" class="TQ_width_44px TQ_margin_4px TQ_verticalAlignMiddle TQ_borderRadius"/>
                        <img :src="ass_img_plusSign_b" class="TQ_width_28px TQ_margin_4px TQ_verticalAlignMiddle"/>
                        <img :src="ass_img_logoApplePhone_c" class="TQ_width_44px TQ_margin_4px TQ_verticalAlignMiddle"/>
                        <img :src="ass_img_equal_b" class="TQ_width_28px TQ_margin_4px TQ_verticalAlignMiddle"/>
                        <img :src="ass_img_logoSafariOrChrome" class="TQ_width_80px TQ_margin_4px TQ_verticalAlignMiddle"/>
                    </div>
                </div>

                <!-- windows -->
                <div v-if="co_isWindows_b" >
                    <div>
                        {{ass_strings.sentence_browserSuggestionsWindows[p_system_langCode_e]}}.
                    </div>
                    <div class="TQ_padding_8px"></div>
                    <div class="TQ_direction_ltr" >
                        <img :src="ass_img_logoFull_p" class="TQ_width_44px TQ_margin_8px TQ_verticalAlignMiddle TQ_borderRadius"/>
                        <img :src="ass_img_plusSign_b" class="TQ_width_28px TQ_margin_8px TQ_verticalAlignMiddle"/>
                        <img :src="ass_img_windows_c" class="TQ_width_44px TQ_margin_8px TQ_verticalAlignMiddle"/>
                        <img :src="ass_img_equal_b" class="TQ_width_28px TQ_margin_4px TQ_verticalAlignMiddle"/>
                        <img :src="ass_img_chrome_c" class="TQ_width_44px TQ_margin_8px TQ_verticalAlignMiddle"/>
                    </div>
                </div>

                <!-- mac -->
                <div v-if="co_isMac_b">
                    <div>
                        {{ass_strings.sentence_browserSuggestionsApple[p_system_langCode_e]}}.
                    </div>
                    <div class="TQ_padding_8px"></div>
                    <div class="TQ_direction_ltr" >
                        <img :src="ass_img_logoFull_p" class="TQ_width_44px TQ_margin_8px TQ_verticalAlignMiddle TQ_borderRadius"/>
                        <img :src="ass_img_plusSign_b" class="TQ_width_28px TQ_margin_2px TQ_verticalAlignMiddle"/>
                        <img :src="ass_img_logoApplePc_c" class="TQ_width_44px TQ_margin_8px TQ_verticalAlignMiddle"/>
                        <img :src="ass_img_equal_b" class="TQ_width_28px TQ_margin_2px TQ_verticalAlignMiddle"/>
                        <img :src="ass_img_logoSafariOrChrome" class="TQ_width_80px TQ_margin_8px TQ_verticalAlignMiddle"/>
                    </div>
                </div>
            </div>

            <hr>

            <!--<div v-if="co_isAndroid_b"-->
                 <!--@click="m_moveToChrome_f"-->
                 <!--class="TQ_Animation_smallBigSmall_infinite TQ_padding_8px TQ_bg_purple TQ_margin_16px TQ_inline TQ_borderRadius TQ_text_24px TQ_clickable TQ_box_shadow">-->
                <!--{{ass_strings.threeWords_openWithChrome[p_system_langCode_e]}}-->
            <!--</div>-->

            <div @click="m_copyCurrentLink_f"
                 class="TQ_bg_purple TQ_Animation_smallBigSmall_infinite TQ_padding_8px TQ_margin_16px TQ_inline TQ_borderRadius TQ_text_24px TQ_clickable TQ_box_shadow">
                {{ass_strings.twoWords_copyLink[p_system_langCode_e]}}
            </div> <br>

            <div class="lc_or_container">
                <hr>
                <div class="lc_or TQ_box_shadow TQ_center TQ_bg_gray1"> {{ass_strings.oneWord_or[p_system_langCode_e]}} </div>
            </div>

            <div @click="pe_continueWithCurrentBrowser_f" class="TQ_link TQ_padding_8px TQ_inline TQ_borderRadius TQ_text_bold TQ_clickable">
                {{ass_strings.fourWords_continueWithCurrentBrowser[p_system_langCode_e]}}
            </div>

        </div>

    </div>

</template>

<script>

    import {enum_langCodes, enum_runIn_es} from "../../../functions/src/shareCode/Share_S_Enum"
    import {validator_enum_fb} from "../../../functions/src/shareCode/Share_S_Validator"
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary"
    import {
        ass_img_arrow_left_p,
        ass_img_chrome_c,
        ass_img_equal_b,
        ass_img_logoAndroid_c,
        ass_img_logoApplePc_c,
        ass_img_logoApplePhone_c,
        ass_img_logoFull2_p,
        ass_img_logoFull_p,
        ass_img_logoSafariOrChrome,
        ass_img_plusSign_b,
        ass_img_windows_c
    } from "../../assets/scripts/Ass_Files";
    import {route_getCurrentFullPath_s, route_moveToChrome_f} from "../../router";
    import {helper_copyStringToClipboard, helper_getDirectionByLangCode_fe} from "../../scripts/S_Helper";
    import {notification_notify} from "../../scripts/S_Notification";

    export default {
        name: "C_App_browserSuggestions",
        props :{
            p_runIn_es : {
                type: String,
                require: true,
                validator (val_e) {
                    return validator_enum_fb(enum_runIn_es, val_e)
                }
            },
            pe_continueWithCurrentBrowser_f:{
                type : Function,
                require: true
            },
            p_system_langCode_e :{
                type: String,
                require: true,
                validator (val_e) {
                    return validator_enum_fb(enum_langCodes, val_e)
                }
            }

        },
        data() {
            return {
                enum_runIn_es : enum_runIn_es,
                ass_img_logoFull_p : ass_img_logoFull_p,
                ass_strings : ass_strings,
                ass_img_chrome_c : ass_img_chrome_c,
                ass_img_windows_c : ass_img_windows_c,
                ass_img_logoApplePhone_c : ass_img_logoApplePhone_c,
                ass_img_arrowLeft_p : ass_img_arrow_left_p,
                ass_img_logoAndroid_c : ass_img_logoAndroid_c,
                ass_img_logoFull2_p : ass_img_logoFull2_p,
                ass_img_plusSign_b : ass_img_plusSign_b,
                ass_img_equal_b : ass_img_equal_b,
                ass_img_logoSafariOrChrome : ass_img_logoSafariOrChrome,
                ass_img_logoApplePc_c : ass_img_logoApplePc_c,
                helper_getDirectionByLangCode_fe : helper_getDirectionByLangCode_fe,
            }
        },
        computed:{
            co_isAndroid_b(){
                return this.p_runIn_es === enum_runIn_es.android_web_other
            },
            co_isIos_b(){
                return this.p_runIn_es === enum_runIn_es.ios_web_other
            },
            co_isWindows_b(){
                return this.p_runIn_es === enum_runIn_es.windows_other
            },
            co_isMac_b(){
                return this.p_runIn_es === enum_runIn_es.mac_other
            }
        },
        methods:{
            m_moveToChrome_f(){
                route_moveToChrome_f()
            },
            m_copyCurrentLink_f(){
                let path_s = route_getCurrentFullPath_s()
                helper_copyStringToClipboard(path_s)
                notification_notify(ass_strings.twoWords_copiedLink)

            }
        }
    }
</script>

<style scoped lang="scss">

    hr {
        margin-right: -16px;
        margin-left: -16px;
    }

    /* or */
    .lc_or_container{
        padding: 8px 0px;

        .lc_or{
            margin-top: -28px;
            width: 32px;
            height: 32px;
            border-radius: 50%;
            color: #fff;
            line-height: 32px;
            text-align: center;
        }
    }
</style>